import React from 'react';
import ColumnCenter from '../../../../../../../components/Layout/ColumnCenter';
import { getWindowWidth } from '../../../../../../../lib/utils/utils';

const SearchInput: React.FC<Props> = ({
  value,
  onChange,
  placeholder,
}) => {
  return (
    <ColumnCenter
      style={{
        width: getWindowWidth() - 30,
        height: 50,
        background: '#ffffff',
        borderRadius: 60,
        border: '1px solid #11202B',
        borderColor: '#989898',
        margin: '25px auto 0 auto',
      }}
    >
      <input
        style={{
          width: getWindowWidth() - 55,
          border: 'none',
          outline: 'none',
          fontSize: 15,
          fontFamily: 'Squad-Regular, Squad',
          fontWeight: 400,
          color: '#11202B',
          lineHeight: '24px',
          backgroundColor: '#ffffff',
        }}
        placeholder={placeholder}
        type="text"
        value={value || ''}
        onChange={(e) => {
          onChange(e.target.value);
        }}
      />
    </ColumnCenter>
  );
};

export interface Props {
  value?: string;
  placeholder?: string;
  onChange: (searchKey: string) => void;
}

export default SearchInput;
